export default __webpack_public_path__ + "static/RootSans-11Black-4d78c90a2cef4a094065f216310fd2eb.woff2";